import { Component, forwardRef, Input, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const CUSTOM_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DropdownYearsComponent),
  multi: true,
};

@Component({
    selector: 'odq-dropdown-years',
    providers: [CUSTOM_VALUE_ACCESSOR],
    templateUrl: './dropdown-years.component.html',
    styleUrls: ['./dropdown-years.component.scss'],
    standalone: false
})
export class DropdownYearsComponent implements ControlValueAccessor {

  @Input() placeholder;
  @ViewChild('inputField', { static: true }) inputField;

  public disabled: boolean;
  public range = [];

  private inputValue: string;
  private onChange: Function;
  private onTouched: Function;

  private years = new Date().getFullYear();

  @Input() set numberYears(nbRange: any) {

    let nbLast = 0;
    if (nbRange[0] == undefined || nbRange[1] == undefined) {
      this.years -= 20;
      nbLast = 40;
    } else {
      this.years -= nbRange[0];
      nbLast = nbRange[0] + nbRange[1];
    }

    for (let i = 0; i < nbLast; i++) {
      this.range.push(this.years + i);
    }
  }

  constructor(private renderer: Renderer2) {
    this.onChange = (_: any) => { };
    this.onTouched = () => { };
    this.disabled = false;
  }

  updateValue($event) {
    const value = $event.currentTarget.value;
    this.inputValue = value;
    this.onChange(this.inputValue);
    this.onTouched();
  }

  writeValue(obj: any): void {
    this.inputValue = obj;
    const inputTag = this.inputField.nativeElement;
    this.renderer.setProperty(inputTag, 'value', this.inputValue);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
